export default __webpack_public_path__ + "static/media/item_5@3x.697dc040.png";